export const httpConstants = {
  METHOD_TYPE: {
    POST: 'POST',
    PUT: 'PUT',
    GET: 'GET',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
  } as const,

  CONTENT_TYPE: {
    APPLICATION_JSON: 'application/json',
    MULTIPART_FORM_DATA: 'multipart/form-data',
    APPLICATION_FORM_URLENCODED: 'application/x-www-form-urlencoded',
    IMAGE_PNG: 'image/png',
  } as const,

  DEVICE_TYPE: {
    WEB: 'web',
  } as const,

  API_END_POINT: {} as Record<string, string>,
};

export const formConstants = {
  ACTION_TYPES: {
    UDPATE_STATE: 'UDPATE_STATE',
  } as const,
};

export const keyConstants = {
  USER: 'user',
} as const;

export enum AGENT_REQ_TYPE {
  MUST_HAVE = 'MUST HAVE',
  GOOD_TO_HAVE = 'GOOD TO HAVE',
}

export enum FALLBACK_MSG {
  NO_AI_AGENT_N_TOOLS = 'No AI Agents & Tools available',
}

export const statusConstants = {
  UNAPPROVED: 'UNAPPROVED',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
} as const;
